import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';

import appReducer from './store/reducers';

export default combineReducers({
  oidc: oidcReducer,
  app: appReducer,
});
